import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { BodyText } from '@kvdbil/components';

const Container = styled.div`
  padding: 0.5rem 0;
`;

const Text = styled(BodyText).attrs({
  as: 'div'
})`
  display: flex;
  text-align: left;
  padding: 1rem;
  background-color: ${({ theme }) => theme.colors.background.gray};
`;

type Props = {
  id: string;
  children: ReactNode;
};

export const ExplanationText = ({ children, id }: Props) => {
  return (
    <Container id={id}>
      <Text>{children}</Text>
    </Container>
  );
};
